import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { Data } from "@angular/router";
import { BehaviorSubject, of, throwError } from "rxjs";
import { catchError, delay, map } from "rxjs/operators";
import { GamesRepositoryService } from "src/app/pages/games/games-repository.service";
import { SwiperModule } from "swiper/angular";
import { NgClass, AsyncPipe } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { GameCelebrationService } from "src/app/pages/games/services/game-celebration.service";

@Component({
    selector: "app-achievement-celebration",
    templateUrl: "./achievement-celebration.component.html",
    styleUrls: ["./achievement-celebration.component.scss"],
    standalone: true,
    imports: [
        SwiperModule,
        NgClass,
        IonicModule,
        AsyncPipe,
    ],
})
export class AchievementCelebrationComponent implements OnInit {
  goalsData: Data[] = [];
  cardsLength$ = new BehaviorSubject<number>(0);
  cardsStatus = new BehaviorSubject<boolean>(true);
  achievementData: Data[] = [];
  achievementDataArray$ = new BehaviorSubject<Data[]>([]);
  badgesData: Data;
  isDisabled$ = new BehaviorSubject<boolean>(true);
  constructor(
    private bottomSheet: MatBottomSheetRef<AchievementCelebrationComponent>,
    private gamesRepositoryService: GamesRepositoryService,
    private gameCelebrationService: GameCelebrationService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data
  ) {
    // This observables contains the data of goals and badges
    this.goalsData = this.data?.goalsData;
    this.badgesData = this.data?.badgesData;
    this.achievementData = this.data?.achievementData;
  }
  ngOnInit(): void {
    //Empty
    this.setData();
  }
  // This method has been used to Set data
  setData() {
    this.achievementData.sort((a, b) => {
      return a?.update_timestamp - b?.update_timestamp;
    });
    this.achievementDataArray$.next(this.achievementData);
    this.achievementDataArray$
      .pipe(
        catchError((error) => {
          // Handle error
          return throwError(error);
        }),
        delay(5000)
      )
      .subscribe((data: Data) => {
        // This condition is used to check data null and undefined
        if (data !== null && data !== undefined) {
          this.getCardLength(data);
        }
      });
  }

  //This method is used to display index of cards
  cardsIndexChange(currentEvent: Data, achievementData: Data) {
    achievementData[currentEvent[0].realIndex].viewed = true;
    this.getCardLength(achievementData);
  }
  // This method is used to display get Card Length
  getCardLength(achievementData: Data) {
    // Create an observable from the achievement data
    of(achievementData)
      .pipe(map((cards) => cards.filter((card) => !card?.viewed)))
      .subscribe((filteredCards: Data) => {
        try {
          // Variable contain length of tha cards array
          const lengthOFCards = filteredCards?.length;
          // Set the length Of cards
          this.cardsLength$.next(lengthOFCards);
          // Condition for disable OK CTA
          if (filteredCards.length === 0) {
            this.isDisabled$.next(false);
          } else if (filteredCards.length > 0) {
            this.isDisabled$.next(true);
          }
        } catch (error) {
          // Handled Error
          throw new Error(`Achievement Data Not found ${error}`);
        }
      });
  }

  // This method has been used to close the bottom sheet
  closeAchievement() {
    this.bottomSheet.dismiss();
    this.goalsData.forEach((docID) => {
      this.gameCelebrationService?.updateGoalsCurrentData(docID?.id);
    });
    // This method has been used to update the badges details data
    this.badgesData.forEach((docID) => {
      this.gameCelebrationService?.updateBadgesCurrentData(docID?.id);
    });
    // This method  has been  used to update the current celebration document
    this.gameCelebrationService.updateCurrentCelebrationDocument();
  }
}
